// extracted by mini-css-extract-plugin
module.exports = {"field":"FieldTextInputLongExample_field__savpB","submit":"FieldTextInputLongExample_submit__w_HOb"};